<div class="container-fluid main-content mt-5 pt-5 col-lg-10 col-md-10 col-12">
  <div class="custom-card">
    <div *ngIf="!(afAuth.user | async)" class="alert alert-warning">
      You must be signed in to submit this form. Please <a href="/landing">sign in</a>.
    </div>

    <div class="card-body">
      <h1 class="custom-card-title text-left">New Event</h1>
      <h4 class="text-left">Please Fill Out the Following Form</h4>
      <br>

      <form #eventForm=ngForm>
        <div class="mb-3">
          <label for="status">Event Status: <span class="text-danger">*</span></label>
          <select id="status" class="form-select" [(ngModel)]="formData.status" name="status" required #status="ngModel"
                  [ngClass]="{'is-invalid': status.invalid && status.touched}">
            <option value="" disabled selected>Choose a Status</option>
            <option value="active">Active</option>
            <option value="expired">Expired</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>

        <div class="mb-3">
          <label for="name"><span class="text-danger">*</span> Event Name:</label>
          <input id="name" class="form-control" [(ngModel)]="formData.name" name="name" required #name="ngModel"
                 [ngClass]="{'is-invalid': name.invalid && name.touched}">
        </div>

        <div class="row mb-3">
          <div class="col-6">
            <label for="startDate" class="me-2"><span class="text-danger">*</span> Event Start Date:</label>
            <input id="startDate" type="date" class="form-control" [(ngModel)]="formData.startDate"
                   name="startDate" required #startDate="ngModel"
                   [ngClass]="{'is-invalid': startDate.invalid && startDate.touched}">
          </div>

          <div class="col-6">
            <label for="endDate" class="me-2"><span class="text-danger">*</span> Event End Date:</label>
            <input id="endDate" type="date" class="form-control"
                   [(ngModel)]="formData.endDate" name="endDate" required #endDate="ngModel"
                   [ngClass]="{'is-invalid': endDate.invalid && endDate.touched}">
          </div>
        </div>

        <h5 class="title mb-3">Details</h5>
        <div class="mb-3">
          <label for="link" class="me-2"><span class="text-danger">*</span> Event Web link:</label>
          <input id="link" type="url" class="form-control" [(ngModel)]="formData.webLink" name="link" required
                 #link="ngModel" [ngClass]="{'is-invalid': link.invalid && link.touched}">
        </div>

        <div class="mb-3">
          <label for="description" class="me-2"><span class="text-danger">*</span> Event Description:</label>
          <input id="description" type="text" class="form-control" [(ngModel)]="formData.description" name="description"
                 required #description="ngModel" [ngClass]="{'is-invalid': description.invalid && description.touched}">
        </div>

        <div class="row mb-3">
          <div class="col-6">
            <label for="contactPhone" class="me-2"><span class="text-danger">*</span> Event Contact Phone
              Number:</label>
            <input id="contactPhone"
                   type="text"
                   class="form-control"
                   [(ngModel)]="formData.contactPhone"
                   name="contactPhone"
                   required
                   maxlength="10"
                   minlength="10"
                   #contactPhone="ngModel"
                   [ngClass]="{'is-invalid': contactPhone.invalid && contactPhone.touched}"
                   (keydown)="allowNumbersOnly($event)">
          </div>

          <div class="col-6">
            <label for="contactName" class="me-2"><span class="text-danger">*</span> Event Contact Name:</label>
            <input id="contactName"
                   type="text"
                   class="form-control"
                   [(ngModel)]="formData.contactName"
                   name="contactName"
                   required
                   #contactName="ngModel"
                   [ngClass]="{'is-invalid': contactName.invalid && contactName.touched}">
          </div>
        </div>

        <div class="mb-3">
          <label for="commentary" class="me-2"><span class="text-danger">*</span> Event Commentary:</label>
          <input id="commentary" type="text" class="form-control" [(ngModel)]="formData.commentary" name="commentary"
                 required #commentary="ngModel" [ngClass]="{'is-invalid': commentary.invalid && commentary.touched}">
        </div>

        <div class="d-flex gap-2 justify-content-center">
          <a routerLink="/events" class="btn d-flex align-items-center btn-lg"
             style="background-color: red; color: white">
            Cancel without saving
            <span class="material-symbols-outlined ms-1">close</span>
          </a>
          <button id="submitAnnual" type="submit" class="btn btn-primary btn-lg" (click)="submitForm()"
                  [disabled]="!eventForm.valid">Save
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

